export default __webpack_public_path__ + "static/media/lightbulb.4c93e07b.svg";